import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { TypeRampV2 } from "../../typography";
import { paginationTheme } from "../paginationTheme";

interface StyledTypeRampProps {
    themeMode: RequiredThemeKeys;
}

function shouldForwardProp(propName: string): boolean {
    switch (propName) {
        case "themeMode":
            return false;
    }
    return true;
}

export const StyledTypeRamp = styled(TypeRampV2, {
    shouldForwardProp,
})<StyledTypeRampProps>(
    ({ themeMode }) => `
    padding: ${paginationTheme.text.padding(themeMode)};
    color: ${color("color--text--neutral--default")};
`
);
